import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { machiningPriorityItems } from './data/materialDetailInsights';
import { useUnits } from '../../units/UnitContext';

const MaterialPropertyInsight = ({ insight, value }) => {
  const { unitSystem } = useUnits();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((currentValue) => !currentValue);
  };

  return (
    <article className="material-insight">
      <div className="material-insight-header">
        <div>
          <h3>{insight.title}</h3>
          <p className="material-insight-value">{value}</p>
        </div>
        <button
          className="material-insight-toggle"
          type="button"
          aria-expanded={isExpanded}
          onClick={toggleExpanded}
        >
          {isExpanded ? 'Show less' : 'Learn more'}
          <ChevronDown
            className={isExpanded ? 'isExpanded' : undefined}
            size={17}
            strokeWidth={2}
            aria-hidden="true"
          />
        </button>
      </div>

      <p className="material-insight-short">{insight.short}</p>

      {isExpanded && (
        <div className="material-insight-expanded">
          {insight.relationships && (
            <div className="material-insight-relationship-grid">
              {insight.relationships.map(({ label, result, Icon }) => (
                <div className="material-insight-relationship" key={label}>
                  <Icon size={20} strokeWidth={1.9} aria-hidden="true" />
                  <span>{label}</span>
                  <strong>{result}</strong>
                </div>
              ))}
            </div>
          )}

          {insight.title === 'Tensile Strength' && (
            <div className="material-insight-priority-grid">
              {machiningPriorityItems.map(({ label, Icon }) => (
                <div className="material-insight-priority" key={label}>
                  <Icon size={17} strokeWidth={1.9} aria-hidden="true" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          )}

          {insight.sections.map((section) => (
            <section className="material-insight-section" key={section.title}>
              <h4>{section.title}</h4>
              {section.paragraphs &&
                section.paragraphs.map((paragraph, index) => (
                  <p key={`${section.title}-${index}`}>
                    {typeof paragraph === 'function' ? paragraph(unitSystem) : paragraph}
                  </p>
                ))}
              {section.cards && (
                <div className="material-insight-card-grid">
                  {section.cards.map((card) => (
                    <div className="material-insight-mini-card" key={card.title}>
                      <h5>{card.title}</h5>
                      <p>{card.text}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>
      )}
    </article>
  );
};

export default MaterialPropertyInsight;
